// src/hooks/useResourceOptions.js
import { useEffect, useState } from 'react';
import { getResourceOptions } from '../api/resourceService';

// The lists are defined by the backend and rarely change, so they are fetched once per page load.
let cached = null;

const EMPTY = { resource_types: [], knowledge_types: [], endorsements_required: 3, max_file_size_mb: 50 };

/**
 * Resource types, knowledge types and the endorsement rule, plus label lookups.
 */
const useResourceOptions = () => {
  const [options, setOptions] = useState(cached || EMPTY);

  useEffect(() => {
    if (cached) return;
    let cancelled = false;
    getResourceOptions()
      .then((data) => {
        cached = data;
        if (!cancelled) setOptions(data);
      })
      .catch((err) => console.error('Failed to load resource options:', err));
    return () => { cancelled = true; };
  }, []);

  const resourceType = (key) => options.resource_types.find((t) => t.key === key);
  const knowledgeLabel = (key) => options.knowledge_types.find((t) => t.key === key)?.label || key;

  const required = options.endorsements_required;
  // e.g. "published once 1 expert endorses it" / "once 3 experts endorse it"
  const endorsementRule = required === 1 ? '1 expert endorses it' : `${required} experts endorse it`;

  return { ...options, resourceType, knowledgeLabel, endorsementRule };
};

export default useResourceOptions;
